/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { AbstractObject } from '@src/app/model/abstract-object';
import { UnitCategory } from '@src/app/model/unit-category';

export class UnitType extends AbstractObject {
  name: string;
  categories?: UnitCategory[] = [];
  constructor(o: Partial<UnitType> = {}) {
    super(o);
  }
}
